export const getIsNumberInRange = (num, numberA, numberB, threshold = 0) =>
	Math.min(numberA, numberB) - threshold <= num &&
	num <= Math.max(numberA, numberB) + threshold;
